export default class {
	constructor(config){
		this.config = config;
		this.promo = null;
	}

	seperatedBillingItems(customer, tests, flags, category){
		const items = this.config.billingSeparatedItems.filter(item => {
			return (!item.is_customer || item.is_customer.length === 0 || item.is_customer.includes(customer))
				&& (!item.has_tests || item.has_tests.length === 0 || tests.some(test => item.has_tests.includes(test.test_type_uuid)))
				&& (!item.sample_category_uuid || item.sample_category_uuid === category)
				&& (!item.has_flags || item.has_flags.length === 0 || flags.some(flag => item.has_flags.includes(flag.sample_flag_type_uuid)))
		});

		// filter to unique quick_books_name
		const uniqueItems = items.filter((item, index, self) => index === self.findIndex((t) => (t.quick_books_name === item.quick_books_name)))

		return uniqueItems.map(item => {
			return {
				display_name: item.name,
				package: item.quick_books_name ? item.quick_books_name : item.name,
				price: item.price,
			}
		})
	}
	// MAIN this function is used to calculate and return a sample's "Receipt"
	samplePrice(sample, promo = null, percentDiscount = null, excluded_tests=null){
		this.config.billingPromotions.sort((a,b) => parseFloat(b.discount) - parseFloat(a.discount));

		// if(sample.line_item) return {};
		let tests = sample.sample_tests.filter(test => !test.retest);
		if(excluded_tests) tests = sample.sample_tests.filter(test => !excluded_tests.includes())
		// base billing object.
		let bill = {
			basePrice: 0,
			package: sample.package ? sample.package : null,
			finalPrice: 0,
			subtotal: null,
			afterSubtotal: [],
			customPrice: sample.customPrice ? sample.customPrice : 0,
			discounts: [],
			percentDiscount: null,
			extra_costs: [],
			tests: null,
		}
		//set base test prices
		bill.tests = this.setBasePrices(tests, sample.sample_cert_type.category.uuid)
		// filter out any disabled test prices, this is to show them on the receipt, but strike them out and don't count them as part of the bill.
		const billingBasePrices = bill.tests.filter(test => !test.disabled);

		//If a package wasn't selected already, auto-select one.
		if(!bill.package) bill.package = this.selectPackage(billingBasePrices, sample.sample_flags, sample.customer_id, sample.sample_cert_type.category.uuid);

		//Set base price as well as the final price before subtracting/adding costs.
		bill.basePrice = bill.tests.filter(test => !test.disabled).reduce((total,b) => total+parseFloat(b.basePrice), 0);
		bill.finalPrice = bill.basePrice;

		// Add test pairing discounts(if any)
		const testPairDiscounts = this.setTestPairDiscounts(billingBasePrices).map(discount => ({name: discount.name, discount: parseFloat(discount.discount)}));
		if(testPairDiscounts.length > 0){
			bill.discounts = [...bill.discounts, ...testPairDiscounts]
		}

		//Add bundle discounts(if any)
	  	const bundleDiscount = this.addTestBundleDiscount(billingBasePrices,sample.sample_cert_type.category.uuid);
	  	if(bundleDiscount){
	  		bill.discounts.push({name: bundleDiscount.name, discount: parseFloat(bundleDiscount.discount)})
	  	}

	  	// //Add package to additional costs if it has one greater than 0.
	  	// if(bill.package && bill.package.additional_cost){
	  	// 	bill.extra_costs.push({...bill.package, additional_cost: parseFloat(bill.package.additional_cost)});
		// }

	  	//Add special scenarios(if any) that add to the cost.
	  	let additions = this.addSpecialAdditions(billingBasePrices, sample.sample_flags, sample.customer_id, sample.sample_cert_type.category.uuid);
	  	if(additions.length > 0){
	  		bill.extra_costs = [...bill.extra_costs, ...additions]
		}

	  	//Add special scenarios(if any) that subtract from the cost.
		let specialDiscounts = this.addSpecialDiscounts(billingBasePrices,sample.sample_flags, sample.customer_id,sample.sample_cert_type.category.uuid);
		if(specialDiscounts.length > 0){
			bill.discounts = [...bill.discounts, ...specialDiscounts]
		}

		//Apply the additional and discounted values to the final price
	  	bill.finalPrice = bill.finalPrice + bill.extra_costs.reduce((total,b) => total+b.additional_cost, 0);
		//Add package to additional costs if it has one greater than 0.
		let fixedPrice = this.setFixedPrice(billingBasePrices,sample.sample_flags, sample.customer_id,sample.sample_cert_type.category.uuid);
		if(bill.package && bill.package.additional_cost){
			if(!fixedPrice) bill.finalPrice += parseFloat(bill.package.additional_cost);
			bill.extra_costs.push({...bill.package, additional_cost: parseFloat(bill.package.additional_cost)});
		}
	  	bill.finalPrice = bill.finalPrice - bill.discounts.reduce((total,b) => total+b.discount, 0);

	  	// let fixedPrice = this.setFixedPrice(billingBasePrices,sample.sample_flags, sample.customer_id,sample.sample_cert_type.category.uuid);
	  	// console.log(fixedPrice);
	  	if(fixedPrice){
	  		bill.subtotal = bill.finalPrice;
	  		bill.finalPrice = fixedPrice.amount + (fixedPrice.optional_amount_addition ? fixedPrice.optional_amount_addition : 0)
			bill.afterSubtotal.push({name: `$${bill.finalPrice} - ${fixedPrice.name}`, discount: (bill.subtotal - bill.finalPrice)});
		}
		if(fixedPrice && bill.package && bill.package.additional_cost){
			// let cost = parseFloat(bill.package.additional_cost)
			bill.subtotal += parseFloat(bill.package.additional_cost);
			bill.finalPrice += parseFloat(bill.package.additional_cost)
			// bill.afterSubtotal.push({...bill.package, additional_cost: parseFloat(bill.package.additional_cost)});
		}
	  	//Apply to final price promotional discount if applicable.
			if(Array.isArray(promo)){
				// console.log("PROMOS", promo)
				promo = this.findPromoDiscounts(billingBasePrices, promo, sample.sample_cert_type.category.uuid, bill.finalPrice);
				// console.log("PROMO", promo);
			}else{
				this.promo = promo;
			}
			let canPromo = this.addPromoDiscounts(billingBasePrices,bill.finalPrice, promo, sample.sample_cert_type.category.uuid);
			// console.log("CAN PROMO", canPromo, promo, sample.sample_cert_type.category.uuid);
			if(canPromo) {
					bill.discounts.push(canPromo);
				bill.finalPrice -= canPromo.discount
			}

		//Apply percentage discount to final price if applicable. and format the display for the receipt.
		if(percentDiscount && (!fixedPrice || fixedPrice.allow_percent_discount)){
			const calcPercentDiscount = ((parseFloat(percentDiscount)/100)*bill.finalPrice)
			bill.percentDiscount = '$' +calcPercentDiscount.toFixed(2) +' '+ '('+percentDiscount+'%)'
			bill.finalPrice = bill.finalPrice - calcPercentDiscount
		}

		//Prevent negative totals
		if(bill.finalPrice < 0){
			bill.finalPrice = 0;
		}

		//Set custom price. Custom price is the field value for the total on the billing page. Made for manually changing the price while keeping the original final price.
		bill.customPrice = bill.finalPrice;
	  	return bill;
	}
	setFixedPrice(tests, flags = [], customer = null, category = null){
		let fixedPrices = this.config.billingFixedPrices.filter(fixed => {
			return (!fixed.is_customer || fixed.is_customer.length === 0 || fixed.is_customer.includes(customer))
				&& (!fixed.allowed_categories || fixed.allowed_categories.length === 0 || (!!category && fixed.allowed_categories.includes(category)))
				&& (!fixed.only_has_tests || fixed.only_has_tests.length === 0 || tests.some(test => fixed.only_has_tests.includes(test.test_type_uuid)))
				&& (!fixed.has_flags || fixed.has_flags.length === 0 || flags.some(flag => fixed.has_flags.includes(flag.sample_flag_type_uuid)))
		})
		for(let fixed of fixedPrices){
			let onlyTestCount = fixed.only_has_tests ? fixed.only_has_tests.length : 0;
			let additionTestsCount = fixed.optional_test_additions ? fixed.optional_test_additions.length : 0;
			let onlyTests = !fixed.only_has_tests ? [] : tests.filter(test => fixed.only_has_tests.includes(test.test_type_uuid));
			let additionTests = !fixed.optional_test_additions ? [] : tests.filter(test => fixed.optional_test_additions.includes(test.test_type_uuid));
			let finalCount = onlyTests.length + additionTests.length;
			// console.log((finalCount - (tests.length - finalCount)) === (additionTestsCount+onlyTestCount), tests.length - finalCount,  ((onlyTests.length - (tests.length - finalCount)) === onlyTestCount && additionTests.length === 0));
			if((finalCount - (tests.length - finalCount)) === (additionTestsCount+onlyTestCount) || ((onlyTests.length - (tests.length - finalCount)) === onlyTestCount && additionTests.length === 0)){
				return {...fixed, optional_amount_addition: additionTests.length === 0 ? 0 : fixed.optional_amount_addition};
			}
		}
		return null;
	}
	setBasePrices(tests, category=null){
		return tests.map(test => {
			let priceConfig = this.config.billingTestPrices.find(price => price.test_type_uuid === test.sample_test_type_uuid);
			let price = 0;
			if(priceConfig){
				if(category && priceConfig.category_prices[category]){
					price = priceConfig.category_prices[category] &&priceConfig.category_prices[category].price
						? parseFloat(priceConfig.category_prices[category].price)
						: priceConfig.default_pricing
				}else{
					price = priceConfig.default_pricing;
				}
			}
			return {
				uuid: test.uuid,
				test_type_uuid: test.sample_test_type_uuid,
				name: test.test_type.description,
				test_name: test.test_type.name,
				disabled: test.disabled !== undefined && test.disabled !== false,
				basePrice: price,
				finalPrice: price,
				discounts: null,
			}
		})
	}
	setTestPairDiscounts(billingTests){
		let pairs = this.config.billingTestPairs;
		let discounts = [];
		for(let pair of pairs){
			const tests = billingTests.map(test => test.test_type_uuid).filter(test => pair.has_tests.includes(test));
			if(tests.length === pair.has_tests.length){
				discounts.push(pair);
			}
		}
		return discounts;
	}
	addTestBundleDiscount(tests, category = null){
		let bundles = this.config.billingBundleDiscounts.filter(bundle => {
			return (!bundle.allowed_categories || bundle.allowed_categories.length === 0 || (!!category && bundle.allowed_categories.includes(category)))
				&& (!bundle.allowed_tests || bundle.allowed_tests.length === 0 || tests.some(test => bundle.allowed_tests.includes(test.test_type_uuid)))
				&& (!bundle.has_tests || bundle.has_tests.length === 0 || tests.some(test => bundle.has_tests.includes(test.test_type_uuid)))
				&& (!bundle.excluded_promotions || bundle.excluded_promotions.length === 0 || !bundle.excluded_promotions.includes(this.promo))
		});
		bundles = bundles.sort((a,b) => b.count - a.count);
		for(let bundle of bundles){
			let testCount = bundle.allowed_tests ? tests.filter(test => bundle.allowed_tests.includes(test.test_type_uuid)).length : tests.length;
				if(bundle.condition === "<" && testCount < parseFloat(bundle.count)) return bundle;
				if(bundle.condition === "<=" && testCount <= parseFloat(bundle.count)) return bundle;
				if(bundle.condition === ">" && testCount > parseFloat(bundle.count)) return bundle;
				if(bundle.condition === ">=" && testCount >= parseFloat(bundle.count)) return bundle;
				if(bundle.condition === "===" && testCount === parseFloat(bundle.count)) return bundle;
		}
		return null;
	}
	selectPackage(tests,flags,customer, category = null){
		let packages = this.config.billingPackages.filter(pack => {
			return (!pack.is_customer || pack.is_customer.length === 0 || pack.is_customer.includes(customer))
			&& (!pack.has_tests || pack.has_tests.length === 0 || tests.some(test => pack.has_tests.includes(test.test_type_uuid)))
			&& (!pack.sample_category_uuid || pack.sample_category_uuid === category)
			&& (!pack.has_flags || pack.has_flags.length === 0 || flags.some(flag => pack.has_flags.includes(flag.sample_flag_type_uuid)))
		})
		for(let pack of packages){
			let testsPass = true;
			let categoryPass = true;
			let flagPass = true;
			let customerFlag = true;
			if(pack.is_customer && pack.is_customer.length > 0){
				const isCustomer = pack.is_customer.includes(customer);
				if(!isCustomer){
					customerFlag = false;
				}
			}
			if(pack.has_tests && pack.has_tests.length > 0){
				const allowedTests = tests.map(test => test.test_type_uuid).filter(test => pack.has_tests.includes(test));
				if(allowedTests.length !== pack.has_tests.length){
					testsPass = false;
				}
			}
			if(pack.has_flags && pack.has_flags.length > 0){
				const allowedFlags = flags.map(flag => flag.sample_flag_type_uuid).filter(flag => pack.has_flags.includes(flag));
				if(allowedFlags.length !== pack.has_flags.length){
					flagPass = false;
				}
			}
			if(pack.sample_category_uuid && pack.sample_category_uuid !== category){
				categoryPass = false
			}
			// console.log(testsPass,categoryPass,flagPass)
			if(testsPass && categoryPass && flagPass && customerFlag) return pack;
		}
		return null;
	}
	findPromoDiscounts(tests, promos, category, finalPrice){
		const mappedTestTypes = tests.map(test => test.test_type_uuid);
		const promotions = promos.filter(imperative => {
			return this.config.billingPromotions.find(pr => {
				// console.log("find promo con 0", pr.name, imperative)
				// console.log("find Promo con 1", (imperative === pr.name || (!imperative && (pr.imperative_name === imperative || pr.imperative_name === '') ) || (imperative !== null && pr.imperative_name.toLowerCase() === imperative.toLowerCase())))
				// console.log("find Promo con 2", (!pr.allowed_tests || pr.allowed_tests.length === 0 || tests.some(test => pr.allowed_tests.includes(test.test_type_uuid))))
				// console.log("find Promo con 3", (!pr.allowed_categories || pr.allowed_categories.length === 0 ||  (category && pr.allowed_categories.includes(category))))
				// console.log("find Promo con 4", mappedTestTypes.filter(test => pr.has_tests.includes(test)).length === pr.has_tests.length)
				return ((!imperative && (pr.imperative_name === imperative || pr.imperative_name === '') ) || (imperative !== null && pr.imperative_name.toLowerCase() === imperative.toLowerCase()))
					&& (!pr.allowed_tests || pr.allowed_tests.length === 0 || tests.some(test => pr.allowed_tests.includes(test.test_type_uuid)))
					&& mappedTestTypes.filter(test => pr.has_tests.includes(test)).length === pr.has_tests.length
					&& (!pr.allowed_categories || pr.allowed_categories.length === 0 ||  (category && pr.allowed_categories.includes(category)))
			})
		})
		// console.log("possible promotions", promotions)
		//find billingPromotion with highest discount
		const formattedPromotions = this.config.billingPromotions.filter(promo => {
			return (promotions.includes(promo.imperative_name) || promotions.includes(promo.name) || (!promo.imperative_name || promo.imperative_name === ''))
				&& (!promo.allowed_tests || promo.allowed_tests.length === 0 || tests.some(test => promo.allowed_tests.includes(test.test_type_uuid)))
				&& mappedTestTypes.filter(test => promo.has_tests.includes(test)).length === promo.has_tests.length
				&& (!promo.allowed_categories || promo.allowed_categories.length === 0 ||  (category && promo.allowed_categories.includes(category)))
		});
		// console.log(formattedPromotions, "FORMATTED PROMOTIONS")
		let promo = null;
		let promoDiscount = 0;
		let currentFinalPrice = finalPrice;
		for(let discount of formattedPromotions){
			// console.log(promotion, "PROMOTION")
			// {discount: 95, min_price: 295}
			// console.log(discount, promoDiscount, "DISCOUNT")
			const newFinalPrice = finalPrice - discount.discount < discount.min_price ? discount.min_price : finalPrice - discount.discount;
			// console.log(newFinalPrice, currentFinalPrice, discount, "NEW FINAL PRICE")
			if(newFinalPrice < currentFinalPrice){
				// console.log("better final price", newFinalPrice, discount.name)
				currentFinalPrice = newFinalPrice;
				promo = discount.imperative_name ? discount.imperative_name : discount.name;
			}
		}
		return promo;
	}
	addPromoDiscounts(tests, total, imperative = null, category = null){
		let promo = this.config.billingPromotions.find(pr => {
			// console.log("Add promo con 0", pr.name, imperative)
			// console.log("Add Promo con 1", (imperative === pr.name || (!imperative && (pr.imperative_name === imperative || pr.imperative_name === '') ) || (imperative !== null && pr.imperative_name.toLowerCase() === imperative.toLowerCase())))
			// console.log("Add Promo con 2", (!pr.allowed_tests || pr.allowed_tests.length === 0 || tests.some(test => pr.allowed_tests.includes(test.test_type_uuid))))
			// console.log("Add Promo con 3", (!pr.allowed_categories || pr.allowed_categories.length === 0 ||  (category && pr.allowed_categories.includes(category))))
			return (imperative === pr.name || (!imperative && (pr.imperative_name === imperative || pr.imperative_name === '') ) || (imperative !== null && pr.imperative_name.toLowerCase() === imperative.toLowerCase()))
			&& (total > parseFloat(pr.min_price))
			&& (!pr.allowed_tests || pr.allowed_tests.length === 0 || tests.some(test => pr.allowed_tests.includes(test.test_type_uuid)))
			&& (!pr.allowed_categories || pr.allowed_categories.length === 0 ||  (category && pr.allowed_categories.includes(category)))
		})
		if(promo){
				let allowedTestPass = true,
					requiredTestPass = true,
					allowedCategoryPass = true;
				if(promo.allowed_tests && promo.allowed_tests.length > 0){
					const allowedTests = tests.map(test => test.test_type_uuid).filter(test => promo.allowed_tests.includes(test));
					// console.log(allowedTests, promo.min_test_count)
					if(allowedTests.length < parseFloat(promo.min_test_count)){
						allowedTestPass = false;
					}
				}
				if(promo.has_tests && promo.has_tests.length > 0){
					const requiredTests = tests.map(test => test.test_type_uuid).filter(test => promo.has_tests.includes(test));
					if(requiredTests.length !== promo.has_tests.length){
						// console.log(requiredTests, promo.has_tests, promo, "REQUIRED TESTS FAIL")
						requiredTestPass = false
					}
				}
				if(promo.allowed_categories && promo.allowed_categories.length > 0){
					if(!category || !promo.allowed_categories.includes(category)){
						allowedCategoryPass = false;
					}
				}
				// console.log(allowedTestPass , requiredTestPass , allowedCategoryPass, "promo conditions")
				if(allowedTestPass && requiredTestPass && allowedCategoryPass) {
					let promoDiscount = parseFloat(promo.discount);
					let promoMinPrice = parseFloat(promo.min_price);
					if(total > promoMinPrice){
						if((promoMinPrice+promoDiscount) < total){
							return promo
						}else{
							return {...promo, discount: total - promoMinPrice} ;
						}
					}else{
						return {...promo, discount: 0}
					}
				}
		}
			return null;
	}
	addSpecialAdditions(tests,flags = [],customer, category = null){
		let specialAdditions = this.config.billingSpecials.filter(special => {
			return special.is_addition
			&& (!special.is_customer || special.is_customer.length === 0 || special.is_customer.includes(customer))
			&& (!special.sample_category_uuid || category === special.sample_category_uuid)
			&& (!special.has_tests || special.has_tests.length === 0 || tests.some(test => special.has_tests.includes(test.test_type_uuid)))
			&& (!special.has_flags || special.has_flags.length === 0 || flags.some(flag => special.has_flags.includes(flag.sample_flag_type_uuid)))
		})
		let additions = []
		for(let addition of specialAdditions){
			let testsPass = true;
			let categoryPass = true;
			let flagPass = true;
			let customerFlag = true;
			if(addition.is_customer && addition.is_customer.length > 0){
				const isCustomer = addition.is_customer.includes(customer);
				if(!isCustomer){
					customerFlag = false;
				}
			}
			if(addition.has_tests && addition.has_tests.length > 0){
				const allowedTests = tests.map(test => test.test_type_uuid).filter(test => addition.has_tests.includes(test));
				if(allowedTests.length !== addition.has_tests.length){
					testsPass = false;
				}
			}
			if(addition.has_flags && addition.has_flags.length > 0){
				const allowedFlags = flags.map(flag => flag.sample_flag_type_uuid).filter(flag => addition.has_flags.includes(flag));
				// console.log(allowedFlags, addition.has_flags)
				if(allowedFlags.length !== addition.has_flags.length){
					flagPass = false;
				}
			}
			if(addition.sample_category_uuid && addition.sample_category_uuid !== category){
				categoryPass = false
			}
			// console.log(testsPass, categoryPass, flagPass, 'special')
			if(testsPass && categoryPass && flagPass && customerFlag){
				additions.push({...addition, additional_cost: addition.amount});
			}
		}
		return additions;
	}
	addSpecialDiscounts(tests,flags = [], customer, category = null){
		let specialDiscounts = this.config.billingSpecials.filter(special => {
			return !special.is_addition
				&& (!special.is_customer || special.is_customer.length === 0 || special.is_customer.includes(customer))
				&& (!special.sample_category_uuid || category === special.sample_category_uuid)
				&& (!special.has_tests || special.has_tests.length === 0 || tests.some(test => special.has_tests.includes(test.test_type_uuid)))
				&& (!special.has_flags || special.has_flags.length === 0 || flags.some(flag => special.has_flags.includes(flag.sample_flag_type_uuid)))
		})
		let discounts = []
		for(let discount of specialDiscounts){
			let testsPass = true;
			let categoryPass = true;
			let flagPass = true;
			let customerFlag = true;
			if(discount.is_customer && discount.is_customer.length > 0){
				const isCustomer = discount.is_customer.includes(customer);
				if(!isCustomer){
					customerFlag = false;
				}
			}
			if(discount.has_tests && discount.has_tests.length > 0){
				const allowedTests = tests.map(test => test.test_type_uuid).filter(test => discount.has_tests.includes(test));
				if(allowedTests.length !== discount.has_tests.length){
					testsPass = false;
				}
			}
			if(discount.has_flags && discount.has_flags.length > 0){
				const allowedFlags = flags.map(flag => flag.sample_flag_type_uuid).filter(flag => discount.has_flags.includes(flag));
				if(allowedFlags.length !== discount.has_flags.length){
					flagPass = false;
				}
			}
			if(discount.sample_category_uuid && discount.sample_category_uuid !== category){
				categoryPass = false
			}
			if(testsPass && categoryPass && flagPass && discount){
				discounts.push({...discount, discount: discount.amount});
			}
		}
		return discounts;
	}
}
